export enum ClientConnectAutoRemove {
    Never = 'never',
    AfterFirstAnsweredSession = 'after-first-answered-session',
    AfterFirstSuccessfulSession = 'after-first-successful-session',
}
